import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import CrmContact from "../../model2/crm/contact/model"
import exportToCsv from "../../gd-modules/export-to-csv/export-to-csv"

const debug: false = false
// const debug: string = "CRMContactsResourcesCollection"

export default class CRMContactsResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, CrmContact, options)
    }

    exportToCSV(arrayOfFields: any[], arrayOfIds: string[] = [], fileName: string = 'crm-contacts'): void {
        const list: any[] = []
        // csv header
        const header: string[] = ['Id'] // id always present and is first
        _.map(arrayOfFields, field=>{
            header.push(field.label)
        })
        list.push(header)

        // iterate through models to get export info for each required
        _(this.models)
            .filter(model=>_.isEmpty(arrayOfIds) || arrayOfIds.includes(model.id)) // filter according to arrayOfIds if any
            .map(model=>{ // add row for each resource item
                const values: any[] = [model.id] // id always present and is first

                _.map(arrayOfFields, field=>{
                    debug && console.log(debug, 'exportToCSV values.push', field.fieldId, field.normalizeToCSVValue(model))

                    values.push(field.normalizeToCSVValue(model))
                })

                list.push(values)
            })
            .value()

        debug && console.log(debug, 'exportToCSV', arrayOfFields, list)

        exportToCsv(list, '{0}.csv'.f(fileName))
    }
}